import { MarkdownInput } from "@equidefi/ui/forms";
import type { MarkdownInputProps } from "@equidefi/ui/forms/Input";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartMarkdownInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<MarkdownInputProps, "name" | "value" | "onChange" | "error" | "isInvalid"> & {
  name: TName;
};

function SmartMarkdownInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...markdownProps }: SmartMarkdownInputProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({ name, control });

  return (
    <MarkdownInput
      name={field.name}
      ref={field.ref}
      value={field.value ?? ""}
      onChange={field.onChange}
      isInvalid={!!error}
      error={error?.message}
      {...markdownProps}
    />
  );
}

export default SmartMarkdownInput;
